
<template>
  <section>
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            パスワードをお忘れの方へ
          </p>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <b-field label="Email"
                     message="ご登録されたメールアドレスに再発行のご案内が送信されます。">
              <b-input type="email" v-model="email" maxlength="254">
              </b-input>
            </b-field>
            <b-field position="is-centered" style="text-align: center !important;">
              <a class="button is-primary is-rounded" @click="sendPR()" style="margin-top: 10px;" :disabled="disabled" v-if="!disabled">送信する</a>
              <a class="button is-primary is-rounded" style="margin-top: 10px;" :disabled="disabled" v-if="disabled">送信する</a>
            </b-field>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ModalPasswordReset',
  computed: {
    disabled () {
      return this.email === '' || this.email.indexOf('@') <= 0
    },
    ...mapState('auth', ['user', 'isModalPasswordReset', 'isEmailSent'])
  },
  data () {
    return {
      isModal: false,
      isAuth: false,
      email: ''
    }
  },
  watch: {
    isModalPasswordReset () {
      this.isModal = this.isModalPasswordReset
    },
    isModal () {
      this.isModal ? console.log('isModal: true') : this.setPRModal()
    }
  },
  methods: {
    setPRModal () {
      console.debug('*** Start *** setPRModal')
      this.$store.dispatch('auth/setPRModal')
      console.debug('*** End *** setPRModal')
    },
    sendPR () {
      console.debug('*** Start *** sendPR')
      console.log(process.env.reCAPTCHA_KEY + '\n' + process.env.reCAPTCHA_SEC)
      this.$store.dispatch('auth/sendPR', {'email': this.email})
      var tempEmail = this.email
      this.isModal = false
      this.email = ''
      setTimeout(() => {
        if (!this.isEmailSent) {
          console.info('isEmailSent is false')
          this.sentFailBar(tempEmail)
        } else {
          console.info('isEmailSent is true')
          this.sendedBar(tempEmail)
        }
      }, 2000)
      console.debug('*** End *** sendPR')
    },
    sendedBar (email) {
      console.debug('*** Start *** sendedBar')
      this.$buefy.snackbar.open({
        message: email + ' 様宛にメールを送付いたしましたので、ご確認ください。',
        type: 'is-success',
        position: 'is-top'
      })
    },
    sentFailBar (email) {
      this.$buefy.snackbar.open({
        message: email + 'は無効なメールアドレスです。',
        type: 'is-warning',
        position: 'is-top'
      })
      console.debug('*** End *** sendedBar')
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 24px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.subtitle {
  font-size: 20px;
  font-weight: 700;
}
.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 40px;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalPasswordReset.vue